/**
 * Created by Ram on 15/09/2016.
 */

import React, { Component } from 'react';
import validator from 'validator';
import jwt from "jsonwebtoken";
import moment from 'moment';
import { navigate } from '@reach/router'
import { authenticate, refreshUserSession } from '../../services/api';
import MfaChallenge from './components/MfaChallenge/MfaChallenge';
import { getRegionNameFromEnvVariables } from '../../services/helpers';
import { Button, FormControl, TextField } from '@material-ui/core';
import Spinner from '../presentation/spinner';
import Logo from '../presentation/logo';
import './style.css';

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            username: null,
            password: null,
            errorMessage: null,
            errorField: null,
            maintainTokenTimeout: null,
            mfaType: null,
            mfaSession : null,
            isLoggingIn: false
        };
    };

    handleLogin = () => {
        const idToken = localStorage.getItem("idToken");

        if (!idToken) {
            navigate('/login', { replace: true });
        };

        this.setState({ user: idToken }, () => {
            this.props.setIsUserAuthenticated(true);
            navigate('/', { replace: true });
        });
    };

    persistUserSession = (result) => {
        const accessToken = result.accessToken;
        const idToken = result.idToken;
        const refreshToken = result.refreshToken;
        const userId = jwt.decode(accessToken).sub;

        localStorage.setItem("userId", userId);
        localStorage.setItem("idToken", idToken);
        localStorage.setItem("accessToken", accessToken);
        localStorage.setItem("refreshToken", refreshToken);

        return jwt.decode(idToken);
    };

    maintainToken = () => {
        let refreshToken = localStorage.getItem("refreshToken");
        let accessToken = localStorage.getItem("accessToken");
        let idToken = localStorage.getItem("idToken");

        let user = jwt.decode(idToken);
        let nextExpiry = user.exp-30;
        let timeoutDuration = (nextExpiry-moment().unix())*1000;

        if (timeoutDuration < 0) {
            timeoutDuration = 0;
        };

        if (this.state.maintainTokenTimeout) {
            try {
                clearTimeout(this.state.maintainTokenTimeout);
            } catch(err) {
                console.log("Non-standard timeout state", err);
                //Odd state, shouldn't prevent overriding of timeout. Proceed anyway.
            };
        };

        const timeout = setTimeout(async () => {
            try {
                const session = await refreshUserSession(refreshToken, accessToken);
                this.persistUserSession(session);
            } catch (error) {
                throw error;
            };
            this.maintainToken();
        }, timeoutDuration);

        this.setState({ maintainTokenTimeout: timeout });
    };

    updateFormState = e => {
        let obj = {};
        obj[e.target.id] = e.target.value;
        this.setState(obj);
    };

    validateState = () => {
        let errorMessage = null;
        let errorField = null;
        let userName = this.state.username;
        let password = this.state.password;

        if ( !userName ) {
            errorField = 'username';
            errorMessage = "Email is a required field.";
        } else if (!validator.isEmail(userName)){
            errorField = 'username';
            errorMessage = "Please enter a valid email address.";
        } else if ( !password ) {
            errorField = 'password';
            errorMessage = "Password is a required field.";
        } else if (password.length < 8){
            errorField = 'password';
            errorMessage = "Password should be minimum 8 characters.";
        };

        if ( errorMessage ) {
            this.setState({errorMessage, errorField});
            return false;
        };

        return true;
    };

    handleKeyPress = e => {
        if(e.which == 13) {
            e.preventDefault();
            this.handleSubmit(e);
        }
    };

    handleError = (json, self) => {
        self.setState({errorMessage: json.errorMessage, errorField: json.errorField});
    };

    resolveSuccessfulSignIn = (result) => {
        const user = jwt.decode(result?.idToken);

        if (!user["custom:superAdmin"]) {
            this.setState({ 
                isLoggingIn: false,
                mfaType: null,
                errorMessage: 'User does not have permissions for Blueconnect', 
                errorField: 'form'
            });
        } else {
            this.persistUserSession(result);
            this.maintainToken();
            this.handleLogin();
        };
    };

    handleSubmit = async () => {
        let userName = this.state.username;
        let password = this.state.password;
        
        if (!this.validateState()) {
            return;
        };

        this.setState({ isLoggingIn: true });

        try {
            const result = await authenticate(userName, password);
            if (result?.type) {
                if (result.type === "MfaSetupRequired") {
                    return this.setState({ 
                        isLoggingIn: false,
                        mfaType: result.type, 
                        errorMessage: "Please complete MFA Set-up via Canvas to log-in", 
                        errorField: "form" 
                    });
                };
               
                if (result.type === "MfaChallenge") {
                    return this.setState({ 
                        isLoggingIn: false,
                        errorMessage: null,
                        mfaType: result.type, 
                        mfaSession: result.session 
                    });
                };
            };

            if (result.statusCode === 201) {
                return this.setState({ 
                    isLoggingIn: false, 
                    errorMessage: "MFA must be set-up and enabled via Canvas to log-in", 
                    errorField: "form"
                });
            };

            console.error("Unrecognised Sign In Response", result);
            return this.setState({ isLoggingIn: false });
        } catch (error) {
            const message = error?.response?.data?.errorMessages?.errorDescription;
            console.error(error);
            if (message.length) {
                console.error(message);
            };
            this.setState({ 
                isLoggingIn: false, 
                errorMessage: 'Incorrect username or password.', 
                errorField: 'form'
            });
        };
    };

    clearMfaSession = () => {
        this.setState({ 
            isLoggingIn: false, 
            mfaType: null, 
            mfaSession: null 
        });
    };

    render = () => {
        const { mfaType, mfaSession, username } = this.state;

        if (mfaType === "MfaChallenge") {
            return (
                <div className='container text-center login-wrapper'>
                    <MfaChallenge 
                        mfaSession={mfaSession} 
                        clearSession={this.clearMfaSession} 
                        onSignInSuccess={this.resolveSuccessfulSignIn} 
                        email={username} 
                    />
                </div>
            );
        };

        return (
            <div className='container text-center login-wrapper'>
                <Logo />
                <h4>{getRegionNameFromEnvVariables()}</h4>
                <br />
                <br />

                <form className="login-form">
                    <div className="sign-in-label-wrapper">
                        <h4 className='sign-in-label'>Sign In</h4>
                    </div>
                
                    <h5 className='login-error-message'>{this.state.errorField === 'form' && this.state.errorMessage}</h5> 

                    {!this.state.isLoggingIn ? (
                            <>
                                <FormControl fullWidth className="form-control-wrapper">
                                    <TextField
                                        id="username"
                                        label="Email"
                                        aria-describedby="email-address"
                                        required
                                        fullWidth
                                        onChange={this.updateFormState}
                                        onKeyPress={this.handleKeyPress}
                                        error={this.state.errorField === 'username'}
                                        helperText={this.state.errorField === 'username' && this.state.errorMessage} />
                                </FormControl><FormControl fullWidth className="form-control-wrapper">
                                        <TextField
                                            id="password"
                                            label="Password"
                                            aria-describedby="email-address"
                                            required
                                            fullWidth
                                            onChange={this.updateFormState}
                                            onKeyPress={this.handleKeyPress}
                                            type="password"
                                            error={this.state.errorField === 'password'}
                                            helperText={this.state.errorField === 'password' && this.state.errorMessage} />
                                    </FormControl><FormControl fullWidth className="button-form-control-wrapper">
                                        <Button
                                            fullWidth
                                            type='button'
                                            variant='contained'
                                            disableElevation
                                            onClick={this.handleSubmit}
                                            color="primary"
                                        >
                                            Log In
                                        </Button>
                                    </FormControl>
                                

                                <a className="forgot-password" href={process.env.POINT_ACCESS_URL+"/forgot-password"} target="_blank"><p>Forgot password?</p></a>  
                            </>
                        ) : (
                            <div className="spinner_wrapper">
                                <Spinner size="80" />
                            </div>
                        )
                    }
                </form>
            </div>
        );
    };

};

export default Login;
